// @ts-check
export const formatPercent = number => `${number * 100}%`

export const addCommas = input => {
  const string = (input && input.toString()) || ''
  if (string.length <= 3) {
    return string
  }
  const reversed = string.split('').reverse()

  let result = ''
  reversed.forEach((number, index) => {
    const mod = index % 3
    if (index && !mod) {
      result = number + ',' + result
    } else {
      result = number + result
    }
  })

  return result
}

export const formatEpi = number =>
  number == 0 ? 'no epi' : `1:${addCommas(Math.round(number * 1000))} epi`
